const extractNumbers = (input) => {
    return input.split("").filter(e => {
        return e !== '(' && e !== ')' && e !== '-' && e !== ' ';
    }).join("");
}

export {
    extractNumbers
}
